import { get } from './util'

export const getUnreadNotifications = notifications => {
  return notifications
    .filter(item => {
      const status = get([item, 'attributes', 'status'], 'delivered')
      return !['read', 'deleted'].includes(status)
    })
    .map(item => {
      return item.id
    })
}
